


































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import AbpBase from "@/lib/abpbase";
import MallConfigApi from '@/api/mall/mallConfig/index'
import PicModal from '@/components/upload/picModal.vue'
import SelectUrl from '@/components/selectUrl/index.vue'
import SelectPcUrl from '@/views/shopMall/pcMallDecorate/floorSet/components/selectUrl.vue'

@Component({
  components: {
    PicModal,
    SelectUrl,
    SelectPcUrl
  }
})
export default class ProductAdvertSetting extends AbpBase {
  key = 'DetailPageAdvertConfig'
  showPcPicModal = false
  showMobilePicModal = false
  data = {
    ads: {
      pcPictureUrl: '',
      pcLink: '',
      mobilePictureUrl: '',
      mobileLink: ''
    }
  }
  /**
   * 选择图片
   */
  pcPicChange(event) {
    console.log('event: ', event)
    this.data.ads.pcPictureUrl = event[0].url
  }
  mobilePicChange(event) {
    this.data.ads.mobilePictureUrl = event[0].url
  }

  mounted() {
    this.loadConfig()
  }
  mobileUrlChange(e) {
    this.data.ads.mobileLink = e
  }
  pcUrlChange(e) {
    this.data.ads.pcLink = e
  }
  save() {
    MallConfigApi.updateMallConfig(
      this.key,
      '商品详情广告设置',
      this.data
    ).then(res => {
      this.$Message.success('保存成功')
    })
  }
  loadConfig() {
    MallConfigApi.getMallConfig(this.key).then(res => {
      if (res.data) {
        this.data = res.data
      }
    })
  }
  deleteFn(type){
    this.data.ads[type] = ''
  }
}
